module.exports = __webpack_public_path__ + "static/2front-about-company-2-b4b5c9c5ee34979476b4dd2e415a1aff.png";